export default __webpack_public_path__ + "static/media/jackpot-modal__symbol.582a210f.png";